export default __webpack_public_path__ + "static/sara-soueidan-3eea893db7f544f8c98a5eb3ca2f0a18.jpg";